import { render, staticRenderFns } from "./TabTrainings.vue?vue&type=template&id=730ae73a&"
import script from "./TabTrainings.vue?vue&type=script&lang=js&"
export * from "./TabTrainings.vue?vue&type=script&lang=js&"
import style0 from "./TabTrainings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabTrainings.vue"
export default component.exports